import React, { useEffect, useState } from 'react';
import MedibuddyLogo from '../../assets/homepage/mb_logo.svg';
import AdityaBirlaPNG from '../ABHFL/adityabirla.png';
import 'font-awesome/css/font-awesome.min.css';
import Grid from '@material-ui/core/Grid';
import useDataStore from '../../store/dataStore';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    padding: "1% 0% 2% 2%", // Add some padding to the header
  },
  logosContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: {
    width: '100%', // Make both logos take full width
    maxWidth: '120px', // Limit the maximum width for larger screens
    height: 'auto',
    objectFit: 'contain',
  },
}));

function CustomHeader(props) {
  const [source, setSource] = useState("");
  const data = useDataStore((state) => state.data);
  const classes = useStyles();

  useEffect(() => {
    setSource(localStorage.getItem("source"))
  }, []);

  return (
    <div className={classes.header}>
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6} md={6}>
          <div className={classes.logosContainer}>
            <a href={getHomepage()}>
              <img src={MedibuddyLogo} alt="" className={classes.logo} />
            </a>
          </div>
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <div className={classes.logosContainer} style={props.style}>
            <img src={AdityaBirlaPNG} alt="" className={classes.logo} />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

function getHomepage() {
  return ('/abhfl_home?utm_source=' + localStorage.getItem("source"));
}

export default CustomHeader;
